import { Directive, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";
import { checkAndRemoveTitleWording, keyPressCharacters } from "src/app/functions/string-formatter.function";

@Directive({
  selector: '[normalizeName]'
})
export class NormalizeNameDirective {

  constructor(private ngControl: NgControl) {}
  
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const isValid = keyPressCharacters(event);
    if (!isValid) {
      event.preventDefault();
    }
  }   

  @HostListener('blur')
  onBlur() {
    const control = this.ngControl.control;
    if (!control || !control.value) return;

    const newValue = checkAndRemoveTitleWording(control.value);
    control.setValue(newValue, { emitEvent: false });
  }
}